// extracted by mini-css-extract-plugin
module.exports = {"FlexWrapper":"DownloadSection-module--FlexWrapper--tNitP","RecomendationContainer":"DownloadSection-module--RecomendationContainer--2pzr6"};